<template>
  <div class="text-justify">
    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5>
          {{
            [
              "OCPR",
              "CSGAS",
              "OCSG",
              "CSA",
              "CSIA",
              "OCPE",
              "OCLN",
              "OEAP",
              "OICC",
            ].includes(activity)
              ? "4. DETALLES DEL ORGANISMO Y SU ESTRUCTURA"
              : ["OINSP", "OENY", "OEYC"].includes(activity)
              ? "5. DETALLES DEL ORGANISMO Y SU ESTRUCTURA"
              : ""
          }}
        </h5>
      </legend>
    </div>

    <!-- Certificación - Productos -->
    <div v-if="['OCPR'].includes(activity)">
      <responsable-table
        title="4.1 RESPONSABLE DEL FUNCIONAMIENTO DEL ORGANISMO DE CERTIFICACIÓN"
        tableId="responsable-table-rfoc"
        type="RFOC"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />

      <responsable-table
        title="4.2 RESPONSABLE DE ACREDITACIÓN DEL ORGANISMO DE CERTIFICACIÓN"
        tableId="responsable-table-pdea"
        type="PDEA"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />
    </div>

    <!-- Certificación - Sistemas de Gestión -->
    <div v-if="['CSGAS', 'OCSG', 'CSA', 'CSIA'].includes(activity)">
      <responsable-table
        title="4.1 RESPONSABLE DEL FUNCIONAMIENTO DEL ORGANISMO DE CERTIFICACIÓN"
        tableId="responsable-table-rfoc"
        type="RFOC"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />

      <responsable-table
        title="4.2. RESPONSABLE DE ACREDITACIÓN DEL ORGANISMO"
        tableId="responsable-table-pdea"
        type="PDEA"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />
    </div>

    <!-- Certificación - Personas -->
    <div v-if="['OCPE'].includes(activity)">
      <responsable-table
        title="4.1 REPRESENTANTE LEGAL DEL ORGANISMO DE CERTIFICACIÓN"
        tableId="responsable-table-rl"
        type="RL"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />

      <responsable-table
        title="4.2 RESPONSABLE DEL FUNCIONAMIENTO DEL ORGANISMO DE CERTIFICACIÓN"
        tableId="responsable-table-rfoc"
        type="RFOC"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />

      <responsable-table
        title="4.3 RESPONSABLE A EFECTOS DE LA ACREDITACIÓN DEL ORGANISMO DE CERTIFICACIÓN"
        tableId="responsable-table-pdea"
        type="PDEA"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />
    </div>

    <!-- Certificación - Inspección -->
    <div v-if="['OINSP'].includes(activity)">
      <responsable-table
        title="5.1 REPRESENTANTE LEGAL"
        tableId="responsable-table-rl"
        type="RL"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />

      <responsable-table
        title="5.2 APODERADO O REPRESENTANTE EN TERRITORIO NACIONAL (cuando aplique)"
        tableId="responsable-table-artn"
        type="ARTN"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />

      <responsable-table
        title="5.3 RESPONSABLE TÉCNICO DEL ORGANISMO DE INSPECCIÓN"
        tableId="responsable-table-rtoi"
        type="RTOI"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />

      <responsable-table
        title="5.4 PERSONA DELEGADA A EFECTOS DE LA ACREDITACIÓN"
        tableId="responsable-table-pdea"
        type="PDEA"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />
    </div>

    <!-- Laboratorio - Ensayos y Calibración -->
    <div v-if="['OENY', 'OEYC'].includes(activity)">
      <responsable-table
        title="5.1 RESPONSABLE(S) DE LAS FUNCIONES Y ACTIVIDADES DE 6.2.6"
        tableId="responsable-table-rfa1"
        type="RFA1"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />

      <responsable-table
        title="5.2 RESPONSABLE(S) DE LAS FUNCIONES Y ACTIVIDADES DEL 5.6 Y 8.3.2"
        tableId="responsable-table-rfa2"
        type="RFA2"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />

      <responsable-table
        title="5.3 PERSONAL AUTORIZADO PARA FIRMAR LOS INFORMES DE RESULTADOS"
        tableId="responsable-table-pafir"
        type="PAFIR"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />
    </div>

    <!-- Laboratorio - Clínico -->
    <div v-if="['OCLN'].includes(activity)">
      <responsable-table
        title="4.1 DIRECCIÓN TÉCNICA DEL LABORATORIO"
        tableId="responsable-table-dtl"
        type="DTL"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />

      <responsable-table
        title="4.2 RESPONSABLE DEL SISTEMA DE GESTIÓN DE CALIDAD"
        tableId="responsable-table-rsgc"
        type="RSGC"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />

      <responsable-table
        title="4.3 PERSONAL AUTORIZADO PARA FIRMAR LOS INFORMES DE RESULTADOS"
        tableId="responsable-table-pafir"
        type="PAFIR"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />
    </div>

    <!-- Laboratorio - Proveedores de Ensayos de Aptitud -->
    <div v-if="['OEAP'].includes(activity)">
      <responsable-table
        title="4.1 DIRECCIÓN TÉCNICA DEL PROVEEDOR DE ENSAYOS DE APTITUD"
        tableId="responsable-table-dtpea"
        type="DTPEA"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />

      <responsable-table
        title="4.2 RESPONSABLE DEL SISTEMA DE GESTIÓN DE CALIDAD"
        tableId="responsable-table-rsgc"
        type="RSGC"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />

      <responsable-table
        title="4.3 COORDINADORES TÉCNICOS DE CADA UNO DE LOS PROGRAMAS"
        tableId="responsable-table-ctcp"
        type="CTCP"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />
    </div>

    <!-- Laboratorio - Investigación y Control de Calidad -->
    <div v-if="['OICC'].includes(activity)">
      <responsable-table
        title="4.1. RESPONSABLE(S) DE LAS FUNCIONES Y ACTIVIDADES DE 6.2.6"
        tableId="responsable-table-rfa1"
        type="RFA1"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />

      <responsable-table
        title="4.2. RESPONSABLE(S) DE LAS FUNCIONES Y ACTIVIDADES DEL 5.6 Y 8.3.2"
        tableId="responsable-table-rfa2"
        type="RFA2"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />

      <responsable-table
        title="4.3. PERSONAL AUTORIZADO PARA FIRMAR LOS INFORMES DE RESULTADOS"
        tableId="responsable-table-pafir"
        type="PAFIR"
        modalTitle="Añadir"
        editModalTitle="Editar"
        :disabled="disabled"
        :activity="activity"
      />
    </div>

    <form
      ref="form"
      data-url="/details"
      class="mb-0"
      :class="{ 'loading-opacity': preloader }"
      v-if="
        [
          'OEYC',
          'OENY',
          'OCLN',
          'OICC',
          'OINSP',
          'OCSG',
          'CSIA',
          'CSA',
          'CSGAS',
          'OCPR',
          'OCPE',
        ].includes(activity)
      "
    >
      <div
        class="row"
        v-if="
          [
            'OEYC',
            'OENY',
            'OCLN',
            'OICC',
            'OINSP',
            'OCSG',
            'CSIA',
            'CSA',
            'CSGAS',
            'OCPR',
            'OCPE',
          ].includes(activity)
        "
      >
        <legend class="col-12 col-form-label text-primary pt-0 mb-3">
          <h5>
            {{
              ["OCPR", "CSGAS", "OCSG", "CSA", "CSIA"].includes(activity)
                ? "4.3 ¿EL SOLICITANTE O LA ORGANIZACIÓN A LA QUE PERTENECE, REALIZA OTRAS ACTIVIDADES ADEMÁS DE AQUELLAS PARA LAS QUE SOLICITA LA ACREDITACIÓN?"
                : ["OCPE", "OCLN"].includes(activity)
                ? "4.4 ¿EL SOLICITANTE O LA ORGANIZACIÓN A LA QUE PERTENECE, REALIZA OTRAS ACTIVIDADES ADEMÁS DE AQUELLAS PARA LAS QUE SOLICITA LA ACREDITACIÓN?"
                : ["OINSP"].includes(activity)
                ? "5.5 ¿EL SOLICITANTE O LA ORGANIZACIÓN A LA QUE PERTENECE, REALIZA OTRAS ACTIVIDADES ADEMÁS DE AQUELLAS PARA LAS QUE SOLICITA LA ACREDITACIÓN?"
                : ["OENY", "OEYC"].includes(activity)
                ? "5.4 ¿EL SOLICITANTE O LA ORGANIZACIÓN A LA QUE PERTENECE, REALIZA OTRAS ACTIVIDADES ADEMÁS DE AQUELLAS PARA LAS QUE SOLICITA LA ACREDITACIÓN?"
                : ["OICC"].includes(activity)
                ? "4.3 ¿REALIZA, YA SEA EL LABORATORIO O BIEN LA ORGANIZACIÓN A LA QUE PERTENECE, OTRAS ACTIVIDADES ADEMÁS DE AQUELLAS PARA LAS QUE SOLICITA LA ACREDITACIÓN?"
                : ""
            }}
          </h5>
        </legend>

        <div class="col-12">
          <div class="form-group">
            <app-input
              type="radio-buttons"
              :list="confirm"
              v-model="inputs.other_activities"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-12" v-if="inputs.other_activities">
          <div class="form-group">
            <label
              >EN CASO AFIRMATIVO, DESCRIBA INDICANDO AQUELLAS QUE REALIZA EL
              {{
                [
                  "OINSP",
                  "OCSG",
                  "CSIA",
                  "CSA",
                  "CSGAS",
                  "OCPE",
                  "OCPR",
                ].includes(activity)
                  ? "ORGANISMO"
                  : "LABORATORIO"
              }}
              Y LAS QUE REALIZA LA ORGANIZACIÓN A LA QUE PERTENECE</label
            >
            <app-input
              type="textarea"
              v-model="inputs.other_activities_description"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>
      </div>

      <div
        class="row"
        v-if="
          [
            'OEYC',
            'OENY',
            'OCLN',
            'OINSP',
            'OCSG',
            'CSIA',
            'CSA',
            'CSGAS',
            'OCPR',
            'OCPE',
          ].includes(activity)
        "
      >
        <legend class="col-12 col-form-label text-primary pt-0 mb-3">
          <h5>
            {{
              ["OCPR", "CSGAS", "OCSG", "CSA", "CSIA"].includes(activity)
                ? "4.4 ¿EL ORGANISMO, HA RECIBIDO CONSULTORÍA EXTERNA?"
                : ["OCPE"].includes(activity)
                ? "4.5 ¿EL ORGANISMO, HA RECIBIDO CONSULTORÍA EXTERNA?"
                : ["OINSP"].includes(activity)
                ? "5.6 ¿EL ORGANISMO, HA RECIBIDO CONSULTORÍA EXTERNA?"
                : ["OENY", "OEYC"].includes(activity)
                ? "5.5 ¿EL LABORATORIO, HA RECIBIDO CONSULTORÍA EXTERNA?"
                : ["OCLN"].includes(activity)
                ? "4.5 ¿EL LABORATORIO, HA RECIBIDO CONSULTORÍA EXTERNA?"
                : ""
            }}
          </h5>
        </legend>

        <div class="col-12">
          <div class="form-group">
            <app-input
              type="radio-buttons"
              :list="confirm"
              v-model="inputs.external_consultancy"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="inputs.external_consultancy">
          <div class="form-group">
            <label>Nombre de la empresa</label>
            <app-input
              type="text"
              v-model="inputs.consultant"
              :required="true"
              :disabled="disabled"
              placeholder="Ingrese el nombre de la empresa"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="inputs.external_consultancy">
          <div class="form-group">
            <label>Fecha en que finalizó <b>(Cuando aplique)</b></label>
            <!-- <app-input
              type="date"
              v-model="inputs.consultation_date"
              :required="true"
              :disabled="disabled"
              placeholder="Ingrese la fecha en que finalizó"
            /> -->
            <app-input
              type="date"
              v-model="inputs.consultation_date"
              :disabled="disabled"
              placeholder="Ingrese la fecha en que finalizó"
            />
          </div>
        </div>

        <div class="col-12" v-if="inputs.external_consultancy">
          <div class="form-group">
            <label>Nombre de los consultores</label>
            <app-input
              type="textarea"
              v-model="inputs.consultants_name"
              :required="true"
              :disabled="disabled"
              placeholder="Ingrese el nombre de los consultores"
            />
          </div>
        </div>

        <p class="col-12 mt-4">
          <b>Nota:</b> El Servicio de Acreditación Ecuatoriano considera un
          tiempo de desvinculación de 2 años como suficiente para minimizar a un
          nivel aceptable los posibles conflictos de interés que se generan por
          relaciones profesionales o comerciales con el SAE.
        </p>
      </div>

      <div
        class="row"
        v-if="
          [
            'OEYC',
            'OENY',
            'OINSP',
            'OCSG',
            'CSIA',
            'CSA',
            'CSGAS',
            'OCPR',
            'OCPE',
          ].includes(activity)
        "
      >
        <legend class="col-12 col-form-label text-primary pt-0 mb-3">
          <h5>
            {{
              ["OCPR", "CSGAS", "OCSG", "CSA", "CSIA"].includes(activity)
                ? "4.5 DESCRIBIR LOS MEDIOS MEDIANTE LOS CUALES LA ORGANIZACIÓN SOLICITANTE OBTIENE FINANCIAMIENTO PARA SUS OPERACIONES"
                : ["OCPE"].includes(activity)
                ? "4.6 DESCRIBIR LOS MEDIOS MEDIANTE LOS CUALES LA ORGANIZACIÓN SOLICITANTE OBTIENE FINANCIAMIENTO PARA SUS OPERACIONES"
                : ["OINSP"].includes(activity)
                ? "5.7 DESCRIBIR LOS MEDIOS MEDIANTE LOS CUALES LA ORGANIZACIÓN SOLICITANTE OBTIENE FINANCIAMIENTO PARA SUS OPERACIONES"
                : ["OENY", "OEYC"].includes(activity)
                ? "5.6 DESCRIBIR LOS MEDIOS MEDIANTE LOS CUALES LA ORGANIZACIÓN SOLICITANTE OBTIENE FINANCIAMIENTO PARA SUS OPERACIONES"
                : ""
            }}
          </h5>
        </legend>

        <div class="col-md-12">
          <div class="form-group">
            <app-input
              type="textarea"
              v-model="inputs.financing_operations"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>
      </div>

      <div class="row" v-if="!disabled">
        <div class="col-12 mt-3">
          <button type="submit" class="btn btn-primary" @click.prevent="submit">
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "#/Accreditation/Resources/assets/js/apiUrl";
import moment from "moment";
export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {},
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
    };
  },

  computed: {
    status() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.status.code
        : null;
    },
    disabled() {
      return !["100", "112"].includes(this.status);
    },

    showFormResponsableAdd() {
      return (
        this.$store.state.accreditation.app != null &&
        [7].includes(
          this.$store.state.accreditation.app.accreditation_activity_id
        )
      );
    },

    showOtherActivities() {
      return (
        this.$store.state.accreditation.app != null &&
        ![1, 3].includes(
          this.$store.state.accreditation.app.accreditation_activity_id
        )
      );
    },

    activity() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.accreditation_activity.code
        : null;
    },
  },

  created() {
    this.data();
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      const data = { ...this.inputs };
      data.consultation_date = this.dateToString(data.consultation_date);
      this.save(data);
    },

    afterSuccess(res) {
      // this.$toastr.s(res.data.message);
      const { data } = res.data;
      this.inputs = data;
      this.inputs.consultation_date = this.stringToDate(data.consultation_date);
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      // this.$store.dispatch("getResponsible");

      this.preloader = true;

      this.axiosGet(
        `${actions.DETAILS}/show?accAppId=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200 && response.data) {
            this.inputs = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    dateToString(date) {
      return date != null ? moment(date).format("YYYY-MM-DD") : null;
    },

    stringToDate(date) {
      return date != null ? new Date(date) : null;
    },
  },
};
</script>
